import React, { useCallback } from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';

import {
  rescheduleClassesCurrentFiltersSelector,
  RESCHEDULE_CLASSES_FILTERS,
  setRescheduleFilterValue,
} from 'features/classCreation';
import { FILTER_TYPE } from 'data/filterType';
import DateInput from 'components/DateInput';
import Field from 'components/Field';
import styles from './RescheduleClassesDateRangeFilter.module.scss';

function RescheduleClassesDateRangeFilter() {
  const dispatch = useDispatch();
  const { fromDate, toDate } = useSelector(
    rescheduleClassesCurrentFiltersSelector
  );

  const handleFromDateChange = useCallback(
    (date) => {
      dispatch(
        setRescheduleFilterValue({
          key: RESCHEDULE_CLASSES_FILTERS.fromDate,
          value: date,
          type: FILTER_TYPE.current,
        })
      );
    },
    [dispatch]
  );

  const handleToDateChange = useCallback(
    (date) => {
      dispatch(
        setRescheduleFilterValue({
          key: RESCHEDULE_CLASSES_FILTERS.toDate,
          value: date,
          type: FILTER_TYPE.current,
        })
      );
    },
    [dispatch]
  );

  return (
    <Field
      label="Date Range"
      labelClassName="h5"
    >
      <div className="row">
        <DateInput
          className={classNames(styles.dateInput, 'm-r-xs')}
          value={fromDate}
          onChange={handleFromDateChange}
          placement="top"
          placeholder="From"
        />
        <DateInput
          className={styles.dateInput}
          value={toDate}
          onChange={handleToDateChange}
          placement="top"
          placeholder="To"
        />
      </div>
    </Field>
  );
}
export default RescheduleClassesDateRangeFilter;
